// src/shared/http/iframe.js
//
// Extracted from the original http-common.js IframeUtil.
// Centralises iframe detection and parent-window messaging.

export const IframeUtil = {
  /** Returns true when the app is running inside an iframe. */
  isIframe() {
    try {
      return window.self !== window.top;
    } catch {
      return true; // cross-origin frames throw — treat as iframe
    }
  },

  /** Backward-compatible alias used by legacy code. */
  isInIframe() {
    return this.isIframe();
  },

  /** Post a typed message to the parent window. */
  postMessage(type, data = {}) {
    if (this.isIframe()) {
      window.parent.postMessage({ type, ...data }, '*');
    }
  },

  /** Backward-compatible alias for postMessage. */
  notifyParent(messageType, messageData = {}) {
    this.postMessage(messageType, messageData);
  },

  /** Convenience helper for the most common parent notification. */
  postTokenExpired() {
    this.postMessage('TOKEN_EXPIRED', {
      message: 'Your session has expired. Please try again.',
    });
  },

  // ── Debounce tracking (prevents duplicate notifications) ──────────
  _lastNotifications: {},
  _debounceTime: 1000,

  debounceNotify(messageType, messageData = {}) {
    const now = Date.now();
    if (
      this._lastNotifications[messageType] &&
      now - this._lastNotifications[messageType] < this._debounceTime
    ) {
      return;
    }
    this._lastNotifications[messageType] = now;
    this.postMessage(messageType, messageData);
  },
};
